var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatedCommunityHome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.389 0.574064C23.4251 0.0970011 29.9116 1.76672 35.1516 6.27957V35.4727H18.389V0.574064ZM21.5977 27.0433V32.2333H31.8968V27.0433H21.5977ZM26.1682 4.76375V23.727H27.3917V5.21388L26.1682 4.76375ZM21.5977 3.83655V23.7154H22.8057V3.92119L21.5977 3.83655ZM30.7042 6.98363V23.7462H31.9199V7.79925L30.7042 6.98363Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9656 35.4805H0.222229V6.24116C5.03517 2.25922 10.5791 0.231709 16.9656 0.504865V35.4805ZM3.41933 32.2257H13.757V27.0472H3.41933V32.2257ZM9.23256 23.7617V4.7638L7.9745 5.24471V23.7501L9.23256 23.7617ZM12.5374 3.93279V23.7578H13.757V3.83276L12.5374 3.93279ZM4.64276 23.7578V6.98368L3.43087 7.80315V23.7463L4.64276 23.7578Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatedCommunityHome);
export default __webpack_public_path__ + "static/media/gated-community-home.192843d2738ac460df5043784cbe8ed4.svg";
export { ForwardRef as ReactComponent };